export enum routes {
  DASHBOARD = '/dashboard',
  TABLES = '/tables',
  LOGIN = '/login',
  OFFICE = '/office',
  DEPARTMENT = '/department',
  USER = '/user'
}
